import { render, staticRenderFns } from "./MiniFormInput.vue?vue&type=template&id=0f3036ba&scoped=true&"
import script from "./MiniFormInput.vue?vue&type=script&lang=js&"
export * from "./MiniFormInput.vue?vue&type=script&lang=js&"
import style0 from "./MiniFormInput.vue?vue&type=style&index=0&id=0f3036ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3036ba",
  null
  
)

export default component.exports